<template>
  <div>
    <v-toolbar
        color="blue darken-3"
        dark
        app
        clipped-left
        fixed
        >
          <v-toolbar-title class="ml-0 pl-3">
            <span class="hidden-xs-only">ASP</span>
          </v-toolbar-title>
            <span class="pl-5">
              <router-link to="Welcome">
                <v-btn icon>
                  Home
                </v-btn>
              </router-link>
            </span>
            <span class="pl-5">
              <router-link to="Login">
                <v-btn icon>
                  Login
                </v-btn>
              </router-link>
            </span>
    </v-toolbar>
    <main>
        <router-view class="pt-4"></router-view>
    </main>
  </div>
</template>

<script>
import Login from '@/components/homepage/Login'
import Register from '@/components/homepage/Register'

export default {
  components: {
    Login,
    Register
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Frontpage.vue